{
  "pageTitle": "Clients panel",
  "pageSubtitle": "Manage advertisers",
  "search": {
    "placeholder": "Search by name..."
  },
  "table": {
    "name": "Name",
    "actions": ""
  },
  "actions": {
    "addClient": "Add client",
    "edit": "Edit",
    "archive": "Archive",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "saved": "Saved",
    "saveFailed": "Failed to save client",
    "archived": "Client has been archived"
  },
  "dialog": {
    "createTitle": "New client",
    "editTitle": "Edit client",
    "archiveTitle": "Archive client",
    "archiveDescription": "This action is irreversible. The client will be hidden from the list.",
    "close": "Close",
    "fields": {
      "acronym": "Acronym",
      "acronymPlaceholder": "e.g. VM",
      "acronymRequired": "Acronym is required",
      "acronymTooLong": "Acronym is too long",
      "acronymInvalidChar": "Acronym must not contain a \"/\"",
      "acronymTaken": "A client with this acronym already exists",
      "addBrand": "Add brand",
      "brandPlaceholder": "Brand name",
      "brandRequired": "Brand cannot be empty",
      "brands": "Brands",
      "brandsHint": "Add optional brands assigned to the client.",
      "name": "Name",
      "nameRequired": "Name is required",
      "nameTaken": "A client with this name already exists",
      "namePlaceholder": "Client name",
      "notes": "Notes",
      "notesPlaceholder": "Additional information...",
      "noBrands": "No brands",
      "removeBrand": "Remove"
    },
    "suggestions": {
      "heading": "Existing clients",
      "noResults": "No results"
    }
  },
  "details": {
    "brands": "Brands",
    "emptyValue": "None",
    "notes": "Notes",
    "title": "Client details"
  },
  "permissionDenied": "You don't have permission to access this page.",
  "empty": {
    "title": "No clients",
    "description": "Add your first client."
  }
}
